import React from 'react';
import Dashboard from '../components/Dashboard/Dashboard';

const NeaElpisData = [
  [
    { date: '15/07/2025', size: 50, colour: 77 },
    { date: '16/07/2025', size: 49, colour: 73 },
    { date: '17/07/2025', size: 51, colour: 70 },
    { date: '18/07/2025', size: 47, colour: 71 },
    { date: '19/07/2025', size: 41, colour: 65 },
    { date: '20/07/2025', size: 40, colour: 62 },
    { date: '21/07/2025', size: 36, colour: 55 },
    { date: '22/07/2025', size: 37, colour: 49 },
    { date: '23/07/2025', size: 30, colour: 31 },
    { date: '24/07/2025', size: 32, colour: 40 },
    { date: '25/07/2025', size: 27, colour: 39 },
  ],
  [22],
  ['25/07/2025 15:11'],
  [27],
  [35],
  [
    { date: '15/07/2025', size: 20, colour: 20 },
    { date: '16/07/2025', size: 24, colour: 35 },
    { date: '17/07/2025', size: 21, colour: 41 },
    { date: '18/07/2025', size: 35, colour: 32 },
    { date: '19/07/2025', size: 41, colour: 23 },
    { date: '20/07/2025', size: 37, colour: 16 },
    { date: '21/07/2025', size: 32, colour: 9 },
    { date: '22/07/2025', size: 30, colour: 18 },
    { date: '23/07/2025', size: 26, colour: 25 },
    { date: '24/07/2025', size: 12, colour: -10 },
    { date: '25/07/2025', size: 22, colour: 25 },
  ],
  ['6.71 hours'],
  [2],
  [-7],
];

const NeaTyhiData = [
  [
    { date: '15/07/2025', size: 20, colour: 20 },
    { date: '16/07/2025', size: 24, colour: 35 },
    { date: '17/07/2025', size: 21, colour: 41 },
    { date: '18/07/2025', size: 35, colour: 32 },
    { date: '19/07/2025', size: 41, colour: 23 },
    { date: '20/07/2025', size: 37, colour: 16 },
    { date: '21/07/2025', size: 32, colour: 9 },
    { date: '22/07/2025', size: 30, colour: 18 },
    { date: '23/07/2025', size: 26, colour: 25 },
    { date: '24/07/2025', size: 12, colour: -10 },
    { date: '25/07/2025', size: 22, colour: 25 },
  ],
  [25],
  ['25/07/2025 18:54'],
  [23],
  [31],
  [
    { date: '15/07/2025', size: 20, colour: 20 },
    { date: '16/07/2025', size: 24, colour: 35 },
    { date: '17/07/2025', size: 21, colour: 41 },
    { date: '18/07/2025', size: 35, colour: 32 },
    { date: '19/07/2025', size: 41, colour: 23 },
    { date: '20/07/2025', size: 37, colour: 16 },
    { date: '21/07/2025', size: 32, colour: 9 },
    { date: '22/07/2025', size: 30, colour: 18 },
    { date: '23/07/2025', size: 26, colour: 25 },
    { date: '24/07/2025', size: 12, colour: -10 },
    { date: '25/07/2025', size: 22, colour: 25 },
  ],
  ['6.56 hours'],
  [5],
  [-2],
];

const DashboardPage = () => {
  const selectedVessel = 'Nea Elpis';

  return (
    <Dashboard vesselPositionData={selectedVessel === 'Nea Elpis' ? NeaElpisData : NeaTyhiData} />
  );
};

export default DashboardPage;
